export const ADD_SEED_ARTIST = 'ADD_SEED_ARTIST';
export const REMOVE_SEED_ARTIST = 'REMOVE_SEED_ARTIST';
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const START_GENERATING = 'START_GENERATING';
export const SET_LOADING_PROGRESS = 'SET_LOADING_PROGRESS';
export const SET_GALAXY_DATA = 'SET_GALAXY_DATA';
export const SELECT_NODE = 'SELECT_NODE';
export const HOVER_NODE = 'HOVER_NODE';
export const SET_PREVIEW_TRACK = 'SET_PREVIEW_TRACK';
export const SET_PLAYING = 'SET_PLAYING';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const RESET = 'RESET';
export const GO_TO_INPUT = 'GO_TO_INPUT';
export const ADD_SEED_AND_REGENERATE = 'ADD_SEED_AND_REGENERATE';
export const LOAD_SAVED_MAP = 'LOAD_SAVED_MAP';
export const MERGE_DRIFT_NODES = 'MERGE_DRIFT_NODES';
export const REMOVE_DRIFT_NODES = 'REMOVE_DRIFT_NODES';
export const QUEUE_SEED = 'QUEUE_SEED';
export const UNQUEUE_SEED = 'UNQUEUE_SEED';
export const CLEAR_SEED_QUEUE = 'CLEAR_SEED_QUEUE';
export const SET_MAP_NAME = 'SET_MAP_NAME';
export const SET_MAP_ID = 'SET_MAP_ID';
export const GO_TO_ACHIEVEMENTS = 'GO_TO_ACHIEVEMENTS';
export const CONSUME_LIBRARY_VIEW = 'CONSUME_LIBRARY_VIEW';
export const VIEW_UNIVERSE = 'VIEW_UNIVERSE';
export const VIEW_COLLISION = 'VIEW_COLLISION';
export const VIEW_UNIVERSE_PREVIEW = 'VIEW_UNIVERSE_PREVIEW';
export const VIEW_COLLISION_PREVIEW = 'VIEW_COLLISION_PREVIEW';
